/** Shared React Query retry resolver. */
export function resolveQueryRetry(failure_count: number, error?: unknown, max_retries = 3): boolean {
  const status = getHttpStatusFromQueryError(error);
  if (status === 404) {
    return false;
  }
  return failure_count < max_retries;
}

function getHttpStatusFromQueryError(error: unknown): number | undefined {
  const err = error as { response?: { status?: number }; status?: number };
  if (typeof err?.response?.status === 'number') {
    return err.response.status;
  }
  if (typeof err?.status === 'number') {
    return err.status;
  }
  return undefined;
}
